module.exports = __webpack_public_path__ + "static/media/dcard_legal.460d8ea8.webp";